import React, { useCallback, useEffect, useRef, useState } from "react";
import "../../features/editAndView/ViewAndEdit.css";
import { GenericTable } from "../../components/genericTable/GenericTable";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Search } from '@mui/icons-material';
import {
  donwloadReportWithStatus,
  downloadMasterDataReport,
  getAdditionalData,
  getAllEntityMetaData,
  getAllEntityMetaDataNew,
  resetPassword,
  resetStatus,
} from "../../services/userService";
import { v4 as uuidv4 } from 'uuid';
import { Loader } from "../../components/loader/Loader";
import { ConfirmationPopUp } from "../../components/popup/confirmationPopUp";
import { popupType } from "../../types/types";
import { Box, Button, IconButton, InputAdornment, Modal, Pagination, PaginationItem, Switch, Tab, TextField } from "@mui/material";
import { GenericPopUp } from "../../components/popup/genericPopUp";
import { Entities } from "../../configurations/ViewAndEdit";
import { modelDataType } from "../../components/userModal/userModalType";
import store from "../../stateManagement/store";
import { useNavigate } from "react-router-dom";
import RenderSvg from "../../components/renderSvg/RenderSvg";
import BackButton from "../../components/Buttons/BackButton/BackButton";
import DownloadLoader from "../../components/popup/downloadLoader";
import GenericFilters from "../../components/genericFilters/genericFilters";
import { genericFilterType } from "../../stateManagement/reducers/genericFilterReducer";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";

import { fetchAndDownloadReport } from "../../services/reportService";
import { outletMetaData, searchPropsType, updateType } from "../editAndView/ViewAndEditType";
import { useSelector } from "react-redux";
import { productMetaData } from "../../components/productModal/ProductModalTypes";
import { DynamicFormPage } from "./DynamicModal";
import { PanoramaSharp } from "@material-ui/icons";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { ConfigurationDashboard } from "../configurationDashboard/configurationDashboard";
import { openPopup } from "../../stateManagement/actions/popupActions";
import { ChannelkartNetworkGet, ChannelkartNetworkPost, ChannelkartNetworkPut } from "../../services/networkService";
import { getAccessToken, getLob } from "../../services/authenticationService";
import GenericFilterSelect from "../collections/components/collectionHomeScreenFilter/GenericFilterSelect";
import MdmFilterSelect from "./MdmFilterSelect";
import axios from "axios";

export const NewViewAndEdit = () => {
  const mdmState = useSelector(() => store.getState()?.mdmDashboardReducer?.currentMdmEntity)
  const { translate } = usePortalTranslation();
  const entity = mdmState?.entityName;
  const navigate = useNavigate();
  const endPoint = store.getState()?.mdmDashboardReducer?.currentMdmEntity?.getAPI ?? "";
  const configAPI = store.getState()?.mdmDashboardReducer?.currentMdmEntity?.configAPI ?? "";
  const toggleAPI = store.getState()?.mdmDashboardReducer?.currentMdmEntity?.toggleAPI ?? "";
  const reportName = store.getState()?.mdmDashboardReducer?.currentMdmEntity?.reportName ?? "";
  const supportedParams = store.getState()?.mdmDashboardReducer?.currentMdmEntity?.supportedParams ?? "";
  const [data, setData] = useState<any[]>([]);
  const [openReportModal, setOpenReportModal] = useState<boolean>(false);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [resetFiltersFlag, setResetFiltersFlag] = useState<boolean>(false);
  const formConfig = useSelector(() => store.getState()?.mdmDashboardReducer?.formConfig);
  const allForms = formConfig?.[0]?.value || [];

  const selectedFormConfig = allForms.find((form: any) => form.formId === mdmState.formId) || {};

  useEffect(() => {
    if (!entity) {
      navigate("/dashboard/updatedFlowMDM");
      return;
    }
    getTableRows(endPoint);
  }, []);
  useEffect(() => {
    // // 
    if (refresh) {
      getTableRows(endPoint, currentPage, searchedValue, undefined, selectedFilterOptions)
    }
  }, [refresh]);


  const [loader, setLoader] = useState(true);

  const [openModal, toggleModal] = useState(false);

  const [modelData, setModelData] = useState<any>();

  const [rows, setRows] = useState([]);

  const [pages, setPages] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);

  const [searchedValue, setSeacrhedvalue] = useState("");

  const [timerId, setTimerId] = useState<NodeJS.Timeout | null>(null);

  const [additionalCached, setAdditionalCached] = useState<any[] | undefined>([]);

  const [genericModalState, setGenericModalState] = useState(false);
  const [genericModalMessage, setGenericModalSMessage] = useState("");
  const [genericModaltype, setGenericModalType] = useState<popupType>("Error");

  const [editLoader, setEditLoader] = useState(false);

  const [confirmationPopUp, setConfirmationPopUp] = useState(false);

  const [popUpMessage, setPopUpMessage] = useState<string>("");

  const popUpSuccessMethod = useRef<() => void>();

  const mdmFiltersRef = useRef<genericFilterType>({})

  // MDM filter UI state
  const [filterDropdownOpen, setFilterDropdownOpen] = useState(false);
  const [filterSearchValue, setFilterSearchValue] = useState("");
  const [activeFilterType, setActiveFilterType] = useState<string>("");
  const [selectedFilterOptions, setSelectedFilterOptions] = useState<Record<string, string[]>>({});

  const lastApiCallTime = useRef<number>(0);

  // NOTE: getTableRows can work in two modes: 'table' (default) and 'filters'
  const getTableRows = async (
    endPoint: string,
    currentPage: number = 1,
    searchedValue?: string,
    options?: { mode?: 'table' | 'filters'; which?: string; q?: string; page?: number; pageSize?: number },
    filterOptions?: Record<string, string[]> 
  ) => {
    try {
      const currApiCallTime = Date.now();

      if (options?.mode !== 'filters') {
        setLoader(true);
        if (currApiCallTime >= lastApiCallTime.current) {
          lastApiCallTime.current = currApiCallTime;
        }
      }

      if (options?.mode === 'filters') {
        const page = options.page || 1;
        const pageSize = options.pageSize || 100;
        const base = 'https://datastream.salescode.ai/table-generic/filter-values';
        const params = new URLSearchParams({
          report: reportName,
          which: options.which || '',
          page: page.toString(),
          pageSize: pageSize.toString(),
        });
        if (options.q && options.q.trim().length > 0) {
          params.append('q', options.q.trim());
        }
        const url = `${base}?${params.toString()}`;
        const BEARER_TOKEN = getAccessToken();
        const X_TENANT_ID = getLob();
        const response = await fetch(url, {
          headers: {
            'authorization': `Bearer ${BEARER_TOKEN}`,
            'x-tenant-id': X_TENANT_ID,
          }
        });
        const json = await response.json();
        const list: string[] = Array.isArray(json?.values?.[options.which || ''])
          ? json.values[options.which || '']
          : [];
        return list;
      } else {
        let url = `https://datastream.salescode.ai/table-generic/search?report=${reportName}&page=${currentPage}&pageSize=30`;

        if (searchedValue && searchedValue.trim().length > 0) {
          url += `&contains=${encodeURIComponent(searchedValue)}`;
        }

        const filtersToUse = filterOptions !== undefined ? filterOptions : selectedFilterOptions;

        Object.entries(filtersToUse).forEach(([filterType, options]) => {
          if (options && options.length > 0) {
            options.forEach(optionValue => {
              url += `&${filterType}=${encodeURIComponent(optionValue)}`;
            });
          }
        });
        const BEARER_TOKEN = getAccessToken();
        const X_TENANT_ID = getLob();
        const response = await fetch(url, {
          headers: {
            'authorization': `Bearer ${BEARER_TOKEN}`,
            'x-tenant-id': X_TENANT_ID,
          }
        });

        const data = await response.json();
        const items = Array.isArray(data?.items) ? data.items : [];

        if (currApiCallTime >= lastApiCallTime.current) {
          setRows(items);
          if (typeof data?.totalPages === "number") {
            setPages(data.totalPages);
          }
        }

        if (currApiCallTime === lastApiCallTime.current) {
          setLoader(false);
        }

        return items;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setGenericMetaData("Something went wrong", "Error", true);
      setRows([]);
      if (options?.mode !== 'filters') {
        setLoader(false);
      }
      return [];
    }
  };
  const debouncingTheSearch = 
    (value: string) => {
      if (timerId) {
        clearTimeout(timerId);
      }
      const newTimerId = setTimeout(() => {
        setLoader(true);
        setCurrentPage(1);
        getTableRows(
          endPoint,
          1, 
          value,
          undefined, 
          selectedFilterOptions 
        );
      }, 200);
      setTimerId(newTimerId);
    }

  const rawActions = mdmState?.actions ?? [];
  const Actions = rawActions.includes("Edit")
    ? rawActions
    : [...rawActions, "Edit"];
  const visibleColumns = mdmState?.tableConfiguration.columns?.filter((columnsMetaData: any) => columnsMetaData.showInTable === true) || [];
  

  const columns: GridColDef[] = mdmState?.tableConfiguration.columns.length
    ? visibleColumns
      .map((columnsMetaData: any) => {
        return {
          disableColumnMenu: true,
          field: columnsMetaData.tableField,
          headerName: translate(entity, columnsMetaData.label).toUpperCase(),
          sortable: false,
          minWidth: 100,
          flex: 1,
          headerAlign: "center",
          align: "center",
          valueGetter: (params: GridRenderCellParams) => {
            const field = params.field;
            const value = params.row?.[field];
            if (value !== undefined && value !== null) {
              return value;
            }
            // return params.row?.extendedAttributes?.[field];
          },
        };
      })
    : [];
  function resetStatusEditBody(
    modelData: modelDataType | productMetaData | outletMetaData
  ) {
    switch (entity) {
      case "User": {
        const changeDataType = modelData as modelDataType;
        const dataObj: updateType = {
          loginId: changeDataType?.loginId,
          userAccountId: changeDataType?.userAccountId,
          activeStatus:
            modelData.activeStatus === "active" ? "inactive" : "active",
        };
        return dataObj;
      }
      case "ProductDetails": {
        const changeDataType = modelData as productMetaData;
        const dataObj: productMetaData = {
          ...changeDataType,
          activeStatus:
            changeDataType.activeStatus === "active" ? "inactive" : "active",
        };
        return dataObj;
      }
      case "OutletDetails": {
        modelData = modelData as outletMetaData;
        const dataObj: outletMetaData = {
          outletCode: modelData.outletCode,
          activeStatus:
            modelData.activeStatus === "active" ? "inactive" : "active",
          activeStatusReason:
            modelData.activeStatus +
            " by " +
            JSON.parse(localStorage.authContext).user.loginId,
          ...(mdmState?.userNameKey && {
            userName: {
              loginId: modelData.userName,
              activeStatus:
                modelData.activeStatus === "active" ? "inactive" : "active",
            }
          })
        };
        return dataObj;
      }
    }
  }

  const generateMesaage = (
    modelData: modelDataType | productMetaData | outletMetaData
  ) => {
    switch (entity) {
      case "User": {
        const changeDataType = modelData as modelDataType;
        return changeDataType.name;
      }
      case "ProductDetails": {
        const changeDataType = modelData as productMetaData;
        return changeDataType.skuDescription;
      }

      case "OutletDetails": {
        const changeDataType = modelData as outletMetaData;
        return changeDataType.outletCode;
      }
    }
  };

  const setGenericMetaData = (
    message: string,
    type: popupType,
    state: boolean
  ) => {
    setGenericModalState(state);
    setGenericModalSMessage(message);
    setGenericModalType(type);
  };

  const updateConfirmationPopData = (
    message: string,
    methodHelper: () => void
  ) => {
    popUpSuccessMethod.current = methodHelper;
    setPopUpMessage(message);
  };

  const setPasswordToDefault = async (modelData: modelDataType | undefined) => {
    try {
      if (modelData && modelData.loginId) {
        const response = await resetPassword(modelData.loginId);
        if (response.status === 200) {
          setGenericMetaData(translate(TranslationEnum.common_portal, "Successfully updated password"), "Success", true);
        } else {
          throw new Error();
        }
      }
    } catch (error) {
      setGenericMetaData(
        "Some Error occured while Updating the password",
        "Error",
        true
      );
    }
  };

  const changeStatusFunction = async (
    modelData: modelDataType | productMetaData | outletMetaData
  ) => {
    try {
      switch (entity) {
        case "User": {
          const requestBody = resetStatusEditBody(modelData);
          const response = await resetStatus("/users", requestBody);
          return response;
        }
        case "ProductDetails": {
          const requestBody = resetStatusEditBody(modelData);
          const response = await resetStatus("/products", requestBody);
          return response;
        }
        case "OutletDetails": {
          const requestBody = resetStatusEditBody(modelData);
          const response = await resetStatus(
            "/outletDetails/update",
            requestBody
          );
          return response;
        }
      }
    } catch (error) {
      return error;
    }
  };

  const updateStatus = async (modelData: any) => {
    try {
      if (!modelData) return;

      const recordId = modelData?.id;
      if (!recordId) {
        setGenericMetaData("Record ID not found", "Error", true);
        return;
      }
      
      const currentStatus = modelData.activeStatus?.toLowerCase();
      const newStatus = currentStatus === "active" ? "INACTIVE" : "ACTIVE";
      
      const toggleEndpoint = `/${toggleAPI}/${recordId}/${newStatus}`;

      const response = await ChannelkartNetworkPut(toggleEndpoint, {});
      
      if (response?.status === 200) {
        setGenericMetaData("Status updated successfully", "Success", true);
        getTableRows(endPoint, currentPage, searchedValue, undefined, selectedFilterOptions);
      } else {
        setGenericMetaData(
          "Some Error occurred while Updating the Status",
          "Error",
          true
        );
        throw new Error();
      }
    } catch (error) {
      setGenericMetaData(
        "Some Error occurred while Updating the Status",
        "Error",
        true
      );
    }
  };
  

  if (Actions.includes("Product Image")) {
    columns.push({
      field: "productImage",
      headerName: "Product Image",
      sortable: false,
      minWidth: 100,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams) => {
        return params.row.blobKey ? (
          <img src={params.row.blobKey} alt="" style={{ height: 50 }} />
        ) : (
          <p>{translate(TranslationEnum.common_portal, "No Image")}</p>
        );
      },
    });
  }

  if (Actions.includes("Image File")) {
    columns.push({
      field: "imageFile",
      headerName: "Image File",
      sortable: false,
      minWidth: 100,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams) => {
        return params.row.blobKey ? (
          <img src={params.row.blobKey} alt="" style={{ height: 50 }} />
        ) : (
          <p>No Image</p>
        );
      },
    });
  }


  if (Actions.includes("Edit")) {
    columns.push({
      field: "Edit",
      headerName: "",
      sortable: false,
      minWidth: 90,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <div
            className="edit-button"
            onClick={() => {
              fetchEditData(params.row);
            }}
          >
            <RenderSvg name="Reset-password" />
          </div>
        );
      },
    });
  }
  if (Actions.includes("ChangeStatus")) {
    columns.push({
      field: "Change Status",
      headerName: "",
      sortable: false,
      minWidth: 90,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams) => {
        const isActive = params.row.active_status === "active";
  
        return (
          <Switch
            checked={isActive}
            onChange={() => {
              setModelData(params.row);
              setConfirmationPopUp(true);
              updateConfirmationPopData(
                translate(
                  TranslationEnum.common_portal,
                  `Are you sure want to ${isActive ? "Deactivate" : "Activate"} {name}`,
                  { name: generateMesaage(params.row) ?? "" }
                ),
                () => {
                  updateStatus(params.row);
                }
              );
            }}
            color="primary"
            inputProps={{ 'aria-label': 'toggle active status' }}
          />
        );
      },
    });
  }
  if (Actions.includes("ResetPassword")) {
    columns.push({
      field: "Reset Password",
      headerName: "",
      sortable: false,
      minWidth: 90,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <div
            className="edit-button"
            onClick={() => {
              setModelData(params.row);
              setConfirmationPopUp(true);
              updateConfirmationPopData(
                translate(TranslationEnum.common_portal, "Are you sure want to reset password for {name}", { "name": generateMesaage(params.row) ?? "" }),
                () => {
                  setPasswordToDefault(params.row);
                }
              );
            }}
          >
            <RenderSvg name="reset" />
            {/* <span className="edit-button-text">{translate(TranslationEnum.common_portal, "Reset Password")}</span> */}
          </div>
        );
      },
    });
  }

  const exportFunctionalityOFMDM = async () => {
    setOpenReportModal(true)
    const response = await downloadMasterDataReport(entity, mdmFiltersRef.current);
    if (response.status === 200) {
      const data = response.data.features;
      if (data && data.length > 0) {
        await fetchAndDownloadReport(data?.[0]?.payload?.url);
        setOpenReportModal(false);
      } else {
        setGenericMetaData(
          "Looks like master data report has not been generated yet",
          "Error",
          true
        );
        setOpenReportModal(false);
      }
    } else {
      setOpenReportModal(false);
      setGenericMetaData(
        "Some Error occured while downloading the master report",
        "Error",
        true
      );
    }
  };

  const searchProps: searchPropsType[] =
    visibleColumns.length !== 0
      ? visibleColumns.map((columnsMetaData: any) => {
          return {
            searchKey: columnsMetaData.id,
            searchFilter: (a: string, b: string) => {
              return a === b;
            },
          };
        })
      : [];

  const fetchEditData = async (rowData: any) => {
    try {
      setEditLoader(true);

      let recordId = rowData?.id;

      if (!recordId) {
        setGenericMetaData("Record ID not found", "Error", true);
        setEditLoader(false);
        return;
      }

      if (!configAPI) {
        setGenericMetaData("Config API not configured", "Error", true);
        setEditLoader(false);
        return;
      }

      const response = await ChannelkartNetworkGet(
        configAPI + "/" + recordId + supportedParams,
      );
      if (response?.data) {
        const payload = Array.isArray(response.data) ? response.data[0] : response.data;
        if (payload) {
          setModelData(payload);
          toggleModal(true);
        } else {
          setGenericMetaData("No data found for the selected record", "Error", true);
        }
      } else {
        setGenericMetaData("No data found for the selected record", "Error", true);
      }

      setEditLoader(false);
    } catch (error: any) {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        setGenericMetaData("Authentication error. Please check your permissions for this entity.", "Error", true);
      } else {
        setGenericMetaData(`Error fetching record data: ${error?.message || 'Unknown error'}`, "Error", true);
      }
      setEditLoader(false);
    }
  };

  return (
    <>
      <div className="content" style={{ paddingBlock: "8px", paddingInline: "8px", backgroundColor: "white", boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)", marginBottom: "10px" }}>
        <div className="edit-header-container">
          {/* <div className="edit-icon-container"><RenderSvg name="Edit-icon-black" /></div> */}
          <IconButton onClick={() => {
            navigate(-1);
          }} size="small">
            <ArrowBack sx={{ fontSize: 20, color: '#333' }} />
          </IconButton>
          <span className="content-text" style={{ fontSize: "18px", fontWeight: 500 }}>{translate(TranslationEnum.common_portal, `Edit a record for ${mdmState?.name}`)}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '8px' }}>

          <MdmFilterSelect
            isOpen={filterDropdownOpen}
            setIsOpen={(open) => {
              setFilterDropdownOpen(open);
              // Reset states when closing the dropdown
              if (!open) {
                setActiveFilterType('');
                setFilterSearchValue('');
              }
            }}
            searchValue={filterSearchValue}
            setSearchValue={(v: string) => {
              setFilterSearchValue(v);
              // Only call filter-values API if dropdown is open and a filter type is active
              if (filterDropdownOpen && activeFilterType) {
                getTableRows(
                  endPoint,
                  1,
                  undefined,
                  { mode: 'filters', which: activeFilterType, q: v }
                );
              }
              
            }}
            selectedOptions={selectedFilterOptions}
            setSelectedOptions={async (opts: Record<string, string[]>) => {
              setSelectedFilterOptions(opts);
              setCurrentPage(1);
              
              await getTableRows(
                endPoint,
                1,
                searchedValue,
                undefined, 
                opts // NEW filterOptions parameter with fresh state
              );
            }}
            activeFilterType={activeFilterType}
            setActiveFilterType={setActiveFilterType}
            visibleColumns={visibleColumns}
            fetchFilterValues={(which: string, q?: string, page: number = 1, pageSize: number = 100) =>
              getTableRows(
                endPoint,
                1,
                undefined,
                { mode: 'filters', which, q, page, pageSize }
              ) as unknown as Promise<string[]>
            }
            onClearAll={async () => {
              setSelectedFilterOptions({});
              setFilterSearchValue('');
              setActiveFilterType(''); // Reset active filter type
              setCurrentPage(1);
              // Pass empty filters object directly
              await getTableRows(
                endPoint,
                1,
                searchedValue,
                undefined, // options
                {} // Empty filters
              );
            }}
          />
          <TextField
            placeholder="Search"
            size="small"
            value={searchedValue}
            onChange={(e) => {
              setSeacrhedvalue(e.target.value);
              debouncingTheSearch(e.target.value);
            }}
            sx={{
              width: 250,
              '& .MuiOutlinedInput-root': {
                height: '36px',
                fontSize: '14px',
                backgroundColor: '#fff'
              },
              '& .MuiInputBase-input': { padding: '8px 12px' },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    sx={{
                      p: 0.6,
                      backgroundColor: '#237C9D',
                      borderRadius: '50%',
                      '&:hover': {
                        backgroundColor: '#1e6b7d'
                      }
                    }}
                  >
                    <Search sx={{ fontSize: 18, color: '#fff' }} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Button
            variant="contained"
            onClick={() => {
              toggleModal(true);
            }}
            sx={{
              backgroundColor: '#237C9D',
              color: '#fff',
              fontSize: '14px',
              textTransform: 'none',
              height: '36px',
              '&:hover': {
                backgroundColor: '#1e6b7d'
              }
            }}
          >
            {translate(TranslationEnum.common_portal, "Add New Record")}
          </Button>
        </div>
      </div>

      <ConfirmationPopUp
        openConfirmModal={confirmationPopUp}
        message={popUpMessage}
        setOpenConfirmModal={() => {
          setConfirmationPopUp(false);
        }}
        successMethod={popUpSuccessMethod.current}
      />


      <Modal
        style={{ zIndex: 100 }}
        open={openModal}
        onClose={() => {
          toggleModal(false);
          setModelData(undefined);
        }}
      >
        <Box>
          <ConfigurationDashboard>
            <DynamicFormPage
              setRefresh={setRefresh}
              mdmState={mdmState}
              formConfig={selectedFormConfig}
              initialData={modelData}
              onBack={() => {
                toggleModal(false);
                setModelData(undefined);
              }
              }
            />
          </ConfigurationDashboard>
        </Box>
      </Modal>


      <GenericPopUp
        type={genericModaltype}
        message={genericModalMessage}
        openGenericModal={genericModalState}
        setOpenGenericModal={() => {
          genericModaltype === 'Success' && getTableRows(endPoint, currentPage, searchedValue);
          setResetFiltersFlag(!resetFiltersFlag);
          mdmFiltersRef.current = {};
          setGenericModalState(false);
        }}
      />
      {loader || editLoader ? (
        <Loader />
      ) : (
        <div className="table-style" style={{ marginTop: "0px", height: "85vh" }}>
          <GenericTable
            searchedProps={searchProps}
            table={{
              rows,
              columns,
              getRowId: (row: any) => row.id ?? row.outlet_id ?? row.outlet_code,
              isOfflineSearchEnable: false,
              hideFooter: true,
            }}
          />
          <div className="pagination">
            <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
              {/* Prev Button */}
              <IconButton
                disabled={currentPage === 1}
                onClick={async () => {
                  const newPage = currentPage - 1;
                  if (newPage < 1) return;
                  setCurrentPage(newPage);
                  await getTableRows(
                    endPoint,
                    newPage,
                    searchedValue,
                    undefined,
                    selectedFilterOptions // Pass current filters
                  );
                }}
              >
                <ArrowBack />
              </IconButton>

              <IconButton
                onClick={async () => {
                  const newPage = currentPage + 1;
                  setCurrentPage(newPage);
                  await getTableRows(
                    endPoint,
                    newPage,
                    searchedValue,
                    undefined,
                    selectedFilterOptions // Pass current filters
                  );
                }}
              >
                <ArrowForward />
              </IconButton>
            </Box>
          </div>
          {openReportModal ? (
            <DownloadLoader
              message={"Your report will be downloaded shortly."}
              openReportModal={openReportModal}
              setOpenReportModal={setOpenReportModal}
            />
          ) : null}
        </div>
      )}
    </>
  );
};





// import React, { useCallback, useEffect, useRef, useState } from "react";
// import "../../features/editAndView/ViewAndEdit.css";
// import { GenericTable } from "../../components/genericTable/GenericTable";
// import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
// import { Search } from '@mui/icons-material';
// import {
//   donwloadReportWithStatus,
//   downloadMasterDataReport,
//   getAdditionalData,
//   getAllEntityMetaData,
//   getAllEntityMetaDataNew,
//   resetPassword,
//   resetStatus,
// } from "../../services/userService";
// import { v4 as uuidv4 } from 'uuid';
// import { Loader } from "../../components/loader/Loader";
// import { ConfirmationPopUp } from "../../components/popup/confirmationPopUp";
// import { popupType } from "../../types/types";
// import { Box, Button, IconButton, InputAdornment, Modal, Pagination, PaginationItem, Switch, Tab, TextField } from "@mui/material";
// import { GenericPopUp } from "../../components/popup/genericPopUp";
// import { Entities } from "../../configurations/ViewAndEdit";
// import { modelDataType } from "../../components/userModal/userModalType";
// import store from "../../stateManagement/store";
// import { useNavigate } from "react-router-dom";
// import RenderSvg from "../../components/renderSvg/RenderSvg";
// import BackButton from "../../components/Buttons/BackButton/BackButton";
// import DownloadLoader from "../../components/popup/downloadLoader";
// import GenericFilters from "../../components/genericFilters/genericFilters";
// import { genericFilterType } from "../../stateManagement/reducers/genericFilterReducer";
// import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";

// import { fetchAndDownloadReport } from "../../services/reportService";
// import { outletMetaData, searchPropsType, updateType } from "../editAndView/ViewAndEditType";
// import { useSelector } from "react-redux";
// import { productMetaData } from "../../components/productModal/ProductModalTypes";
// import { DynamicFormPage } from "./DynamicModal";
// import { PanoramaSharp } from "@material-ui/icons";
// import { ArrowBack, ArrowForward } from "@mui/icons-material";
// import { ConfigurationDashboard } from "../configurationDashboard/configurationDashboard";
// import { openPopup } from "../../stateManagement/actions/popupActions";
// import { ChannelkartNetworkGet, ChannelkartNetworkPost, ChannelkartNetworkPut } from "../../services/networkService";
// import { getAccessToken, getLob } from "../../services/authenticationService";
// import GenericFilterSelect from "../collections/components/collectionHomeScreenFilter/GenericFilterSelect";
// import MdmFilterSelect from "./MdmFilterSelect";
// import axios from "axios";
// import { EnvironmentRegistry } from "../../services/registry/environmentRegistry";

// export const NewViewAndEdit = () => {
//   const mdmState = useSelector(() => store.getState()?.mdmDashboardReducer?.currentMdmEntity)
//   const { translate } = usePortalTranslation();
//   const entity = mdmState?.entityName;
//   const navigate = useNavigate();
//   const endPoint = store.getState()?.mdmDashboardReducer?.currentMdmEntity?.getAPI ?? "";
//   const configAPI = store.getState()?.mdmDashboardReducer?.currentMdmEntity?.configAPI ?? "";
//   const toggleAPI = store.getState()?.mdmDashboardReducer?.currentMdmEntity?.toggleAPI ?? "";
//   const reportName = store.getState()?.mdmDashboardReducer?.currentMdmEntity?.reportName ?? "";
//   const supportedParams = store.getState()?.mdmDashboardReducer?.currentMdmEntity?.supportedParams ?? "";
//   const [data, setData] = useState<any[]>([]);
//   const [openReportModal, setOpenReportModal] = useState<boolean>(false);
//   const [refresh, setRefresh] = useState<boolean>(false);
//   const [resetFiltersFlag, setResetFiltersFlag] = useState<boolean>(false);
//   const formConfig = useSelector(() => store.getState()?.mdmDashboardReducer?.formConfig);
//   const allForms = formConfig?.[0]?.value || [];

//   const selectedFormConfig = allForms.find((form: any) => form.formId === mdmState.formId) || {};

//   useEffect(() => {
//     if (!entity) {
//       navigate("/dashboard/updatedFlowMDM");
//       return;
//     }
//     getTableRows(endPoint);
//   }, []);
//   useEffect(() => {
//     // // 
//     if (refresh) {
//       getTableRows(endPoint, currentPage, searchedValue, undefined, selectedFilterOptions)
//     }
//   }, [refresh]);


//   const [loader, setLoader] = useState(true);

//   const [openModal, toggleModal] = useState(false);

//   const [modelData, setModelData] = useState<any>();

//   const [rows, setRows] = useState([]);

//   const [pages, setPages] = useState(0);

//   const [currentPage, setCurrentPage] = useState(1);

//   const [searchedValue, setSeacrhedvalue] = useState("");

//   const [timerId, setTimerId] = useState<NodeJS.Timeout | null>(null);

//   const [additionalCached, setAdditionalCached] = useState<any[] | undefined>([]);

//   const [genericModalState, setGenericModalState] = useState(false);
//   const [genericModalMessage, setGenericModalSMessage] = useState("");
//   const [genericModaltype, setGenericModalType] = useState<popupType>("Error");
//   const [editLoader, setEditLoader] = useState(false);

//   const [confirmationPopUp, setConfirmationPopUp] = useState(false);

//   const [popUpMessage, setPopUpMessage] = useState<string>("");

//   const popUpSuccessMethod = useRef<() => void>();

//   const mdmFiltersRef = useRef<genericFilterType>({})

//   // MDM filter UI state
//   const [filterDropdownOpen, setFilterDropdownOpen] = useState(false);
//   const [filterSearchValue, setFilterSearchValue] = useState("");
//   const [activeFilterType, setActiveFilterType] = useState<string>("");
//   const [selectedFilterOptions, setSelectedFilterOptions] = useState<Record<string, string[]>>({});

//   const lastApiCallTime = useRef<number>(0);

//   // NOTE: getTableRows can work in two modes: 'table' (default) and 'filters'
//   const getTableRows = async (
//     endPoint: string,
//     currentPage: number = 1,
//     searchedValue?: string,
//     options?: { mode?: 'table' | 'filters'; which?: string; q?: string },
//     filterOptions?: Record<string, string[]> 
//   ) => {
//     try {
//       const currApiCallTime = Date.now();

//       if (options?.mode !== 'filters') {
//         setLoader(true);
//         if (currApiCallTime >= lastApiCallTime.current) {
//           lastApiCallTime.current = currApiCallTime;
//         }
//       }

//       if (options?.mode === 'filters') {
//         const base = 'https://datastream.salescode.ai/table-generic/filter-values';
//         const params = new URLSearchParams({
//           report: reportName,
//           which: options.which || '',
//         });
//         if (options.q && options.q.trim().length > 0) {
//           params.append('q', options.q.trim());
//         }
//         const url = `${base}?${params.toString()}`; 
//         const BEARER_TOKEN = getAccessToken();
//         const X_TENANT_ID = getLob();
//         const response = await fetch(url, {
//           headers: {
//             'authorization': `Bearer ${BEARER_TOKEN}`,
//             'x-tenant-id': X_TENANT_ID ?? "",
//           }
//         });
//         const json = await response.json();
//         const list: string[] = Array.isArray(json?.values?.[options.which || ''])
//           ? json.values[options.which || '']
//           : [];
//         return list;
//       } else {
//         let url = `https://datastream.salescode.ai/table-generic/search?report=${reportName}&page=${currentPage}&pageSize=30`;

//         if (searchedValue && searchedValue.trim().length > 0) {
//           url += `&contains=${encodeURIComponent(searchedValue)}`;
//         }

//         const filtersToUse = filterOptions !== undefined ? filterOptions : selectedFilterOptions;

//         Object.entries(filtersToUse).forEach(([filterType, options]) => {
//           if (options && options.length > 0) {
//             options.forEach(optionValue => {
//               url += `&${filterType}=${encodeURIComponent(optionValue)}`;
//             });
//           }
//         });

//         const BEARER_TOKEN = getAccessToken();
//         const X_TENANT_ID = getLob();
//         const response = await fetch(url, {
//           headers: {
//             'authorization': `Bearer ${BEARER_TOKEN}`,
//             'x-tenant-id': X_TENANT_ID ?? "",
//           }
//         });

//         const data = await response.json();
//         const items = Array.isArray(data?.items) ? data.items : [];

//         if (currApiCallTime >= lastApiCallTime.current) {
//           setRows(items);
//           if (typeof data?.totalPages === "number") {
//             setPages(data.totalPages);
//           }
//         }

//         if (currApiCallTime === lastApiCallTime.current) {
//           setLoader(false);
//         }

//         return items;
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       setGenericMetaData("Something went wrong", "Error", true);
//       setRows([]);
//       if (options?.mode !== 'filters') {
//         setLoader(false);
//       }
//       return [];
//     }
//   };
//   const debouncingTheSearch = 
//     (value: string) => {
//       if (timerId) {
//         clearTimeout(timerId);
//       }
//       const newTimerId = setTimeout(() => {
//         setLoader(true);
//         setCurrentPage(1);
//         getTableRows(
//           endPoint,
//           1, 
//           value,
//           undefined, 
//           selectedFilterOptions 
//         );
//       }, 200);
//       setTimerId(newTimerId);
//     }

//   const rawActions = mdmState?.actions ?? [];
//   const Actions = rawActions.includes("Edit")
//     ? rawActions
//     : [...rawActions, "Edit"];
//   const visibleColumns = mdmState?.tableConfiguration.columns?.filter((columnsMetaData: any) => columnsMetaData.showInTable === true) || [];
//   console.log('All columns:', mdmState?.tableConfiguration.columns);
//   console.log('Visible columns (showInTable = true):', visibleColumns[0].tableField);

//   const columns: GridColDef[] = mdmState?.tableConfiguration.columns.length
//     ? visibleColumns
//       .map((columnsMetaData: any) => {
//         return {
//           disableColumnMenu: true,
//           field: columnsMetaData.tableField,
//           headerName: translate(entity, columnsMetaData.label).toUpperCase(),
//           sortable: false,
//           minWidth: 100,
//           flex: 1,
//           headerAlign: "center",
//           align: "center",
//           valueGetter: (params: GridRenderCellParams) => {
//             const field = params.field;
//             const value = params.row?.[field];
//             if (value !== undefined && value !== null) {
//               return value;
//             }
//             // return params.row?.extendedAttributes?.[field];
//           },
//         };
//       })
//     : [];
//   function resetStatusEditBody(
//     modelData: modelDataType | productMetaData | outletMetaData
//   ) {
//     switch (entity) {
//       case "User": {
//         const changeDataType = modelData as modelDataType;
//         const dataObj: updateType = {
//           loginId: changeDataType?.loginId,
//           userAccountId: changeDataType?.userAccountId,
//           activeStatus:
//             modelData.activeStatus === "active" ? "inactive" : "active",
//         };
//         return dataObj;
//       }
//       case "ProductDetails": {
//         const changeDataType = modelData as productMetaData;
//         const dataObj: productMetaData = {
//           ...changeDataType,
//           activeStatus:
//             changeDataType.activeStatus === "active" ? "inactive" : "active",
//         };
//         return dataObj;
//       }
//       case "OutletDetails": {
//         modelData = modelData as outletMetaData;
//         const dataObj: outletMetaData = {
//           outletCode: modelData.outletCode,
//           activeStatus:
//             modelData.activeStatus === "active" ? "inactive" : "active",
//           activeStatusReason:
//             modelData.activeStatus +
//             " by " +
//             JSON.parse(localStorage.authContext).user.loginId,
//           ...(mdmState?.userNameKey && {
//             userName: {
//               loginId: modelData.userName,
//               activeStatus:
//                 modelData.activeStatus === "active" ? "inactive" : "active",
//             }
//           })
//         };
//         return dataObj;
//       }
//     }
//   }

//   const generateMesaage = (
//     modelData: modelDataType | productMetaData | outletMetaData
//   ) => {
//     switch (entity) {
//       case "User": {
//         const changeDataType = modelData as modelDataType;
//         return changeDataType.name;
//       }
//       case "ProductDetails": {
//         const changeDataType = modelData as productMetaData;
//         return changeDataType.skuDescription;
//       }

//       case "OutletDetails": {
//         const changeDataType = modelData as outletMetaData;
//         return changeDataType.outletCode;
//       }
//     }
//   };

//   const setGenericMetaData = (
//     message: string,
//     type: popupType,
//     state: boolean
//   ) => {
//     setGenericModalState(state);
//     setGenericModalSMessage(message);
//     setGenericModalType(type);
//   };

//   const updateConfirmationPopData = (
//     message: string,
//     methodHelper: () => void
//   ) => {
//     popUpSuccessMethod.current = methodHelper;
//     setPopUpMessage(message);
//   };

//   const setPasswordToDefault = async (modelData: modelDataType | undefined) => {
//     try {
//       if (modelData && modelData.loginId) {
//         const response = await resetPassword(modelData.loginId);
//         if (response.status === 200) {
//           setGenericMetaData(translate(TranslationEnum.common_portal, "Successfully updated password"), "Success", true);
//         } else {
//           throw new Error();
//         }
//       }
//     } catch (error) {
//       setGenericMetaData(
//         "Some Error occured while Updating the password",
//         "Error",
//         true
//       );
//     }
//   };

//   const changeStatusFunction = async (
//     modelData: modelDataType | productMetaData | outletMetaData
//   ) => {
//     try {
//       switch (entity) {
//         case "User": {
//           const requestBody = resetStatusEditBody(modelData);
//           const response = await resetStatus("/users", requestBody);
//           return response;
//         }
//         case "ProductDetails": {
//           const requestBody = resetStatusEditBody(modelData);
//           const response = await resetStatus("/products", requestBody);
//           return response;
//         }
//         case "OutletDetails": {
//           const requestBody = resetStatusEditBody(modelData);
//           const response = await resetStatus(
//             "/outletDetails/update",
//             requestBody
//           );
//           return response;
//         }
//       }
//     } catch (error) {
//       return error;
//     }
//   };

//   const updateStatus = async (modelData: any) => {
//     try {
//       if (!modelData) return;

//       const recordId = modelData?.id;
//       if (!recordId) {
//         setGenericMetaData("Record ID not found", "Error", true);
//         return;
//       }
      
//       const currentStatus = modelData.activeStatus?.toLowerCase();
//       const newStatus = currentStatus === "active" ? "INACTIVE" : "ACTIVE";
      
//       const toggleEndpoint = `/${toggleAPI}/${recordId}/${newStatus}`;

//       const response = await ChannelkartNetworkPut(toggleEndpoint, {});
      
//       if (response?.status === 200) {
//         setGenericMetaData("Status updated successfully", "Success", true);
//         getTableRows(endPoint, currentPage, searchedValue, undefined, selectedFilterOptions);
//       } else {
//         setGenericMetaData(
//           "Some Error occurred while Updating the Status",
//           "Error",
//           true
//         );
//         throw new Error();
//       }
//     } catch (error) {
//       setGenericMetaData(
//         "Some Error occurred while Updating the Status",
//         "Error",
//         true
//       );
//     }
//   };
  

//   if (Actions.includes("Product Image")) {
//     columns.push({
//       field: "productImage",
//       headerName: "Product Image",
//       sortable: false,
//       minWidth: 100,
//       flex: 1,
//       headerAlign: "center",
//       align: "center",
//       disableColumnMenu: true,
//       renderCell: (params: GridRenderCellParams) => {
//         return params.row.blobKey ? (
//           <img src={params.row.blobKey} alt="" style={{ height: 50 }} />
//         ) : (
//           <p>{translate(TranslationEnum.common_portal, "No Image")}</p>
//         );
//       },
//     });
//   }

//   if (Actions.includes("Image File")) {
//     columns.push({
//       field: "imageFile",
//       headerName: "Image File",
//       sortable: false,
//       minWidth: 100,
//       flex: 1,
//       headerAlign: "center",
//       align: "center",
//       disableColumnMenu: true,
//       renderCell: (params: GridRenderCellParams) => {
//         return params.row.blobKey ? (
//           <img src={params.row.blobKey} alt="" style={{ height: 50 }} />
//         ) : (
//           <p>No Image</p>
//         );
//       },
//     });
//   }


//   if (Actions.includes("Edit")) {
//     columns.push({
//       field: "Edit",
//       headerName: "",
//       sortable: false,
//       minWidth: 90,
//       flex: 1,
//       headerAlign: "center",
//       align: "center",
//       disableColumnMenu: true,
//       renderCell: (params: GridRenderCellParams) => {
//         return (
//           <div
//             className="edit-button"
//             onClick={() => {
//               console.log("params.row", params.row)
//               console.log("mdmState", mdmState)
//               fetchEditData(params.row);
//             }}
//           >
//             <RenderSvg name="Reset-password" />
//           </div>
//         );
//       },
//     });
//   }
//   if (Actions.includes("ChangeStatus")) {
//     columns.push({
//       field: "Change Status",
//       headerName: "",
//       sortable: false,
//       minWidth: 90,
//       flex: 1,
//       headerAlign: "center",
//       align: "center",
//       disableColumnMenu: true,
//       renderCell: (params: GridRenderCellParams) => {
//         const isActive = params.row.activeStatus === "active";
  
//         return (
//           <Switch
//             checked={isActive}
//             onChange={() => {
//               setModelData(params.row);
//               setConfirmationPopUp(true);
//               updateConfirmationPopData(
//                 translate(
//                   TranslationEnum.common_portal,
//                   `Are you sure want to ${isActive ? "Deactivate" : "Activate"} {name}`,
//                   { name: generateMesaage(params.row) ?? "" }
//                 ),
//                 () => {
//                   updateStatus(params.row);
//                 }
//               );
//             }}
//             color="primary"
//             inputProps={{ 'aria-label': 'toggle active status' }}
//           />
//         );
//       },
//     });
//   }
//   if (Actions.includes("ResetPassword")) {
//     columns.push({
//       field: "Reset Password",
//       headerName: "",
//       sortable: false,
//       minWidth: 90,
//       flex: 1,
//       headerAlign: "center",
//       align: "center",
//       disableColumnMenu: true,
//       renderCell: (params: GridRenderCellParams) => {
//         return (
//           <div
//             className="edit-button"
//             onClick={() => {
//               setModelData(params.row);
//               setConfirmationPopUp(true);
//               updateConfirmationPopData(
//                 translate(TranslationEnum.common_portal, "Are you sure want to reset password for {name}", { "name": generateMesaage(params.row) ?? "" }),
//                 () => {
//                   setPasswordToDefault(params.row);
//                 }
//               );
//             }}
//           >
//             <RenderSvg name="reset" />
//             {/* <span className="edit-button-text">{translate(TranslationEnum.common_portal, "Reset Password")}</span> */}
//           </div>
//         );
//       },
//     });
//   }

//   const exportFunctionalityOFMDM = async () => {
//     setOpenReportModal(true)
//     const response = await downloadMasterDataReport(entity, mdmFiltersRef.current);
//     if (response.status === 200) {
//       console.log(openReportModal)
//       const data = response.data.features;
//       if (data && data.length > 0) {
//         await fetchAndDownloadReport(data?.[0]?.payload?.url);
//         setOpenReportModal(false);
//       } else {
//         setGenericMetaData(
//           "Looks like master data report has not been generated yet",
//           "Error",
//           true
//         );
//         setOpenReportModal(false);
//       }
//     } else {
//       setOpenReportModal(false);
//       setGenericMetaData(
//         "Some Error occured while downloading the master report",
//         "Error",
//         true
//       );
//     }
//   };

//   const searchProps: searchPropsType[] =
//     visibleColumns.length !== 0
//       ? visibleColumns.map((columnsMetaData: any) => {
//           return {
//             searchKey: columnsMetaData.id,
//             searchFilter: (a: string, b: string) => {
//               return a === b;
//             },
//           };
//         })
//       : [];

//   const fetchEditData = async (rowData: any) => {
//     try {
//       setEditLoader(true);

//       let recordId = rowData?.id;

//       if (!recordId) {
//         setGenericMetaData("Record ID not found", "Error", true);
//         setEditLoader(false);
//         return;
//       }

//       if (!configAPI) {
//         setGenericMetaData("Config API not configured", "Error", true);
//         setEditLoader(false);
//         return;
//       }

//       const response = await ChannelkartNetworkGet(
//         configAPI + "/" + recordId + supportedParams,
//       );
//       if (response?.data) {
//         const payload = Array.isArray(response.data) ? response.data[0] : response.data;
//         console.log("payload", payload)
//         if (payload) {
//           setModelData(payload);
//           toggleModal(true);
//         } else {
//           setGenericMetaData("No data found for the selected record", "Error", true);
//         }
//       } else {
//         setGenericMetaData("No data found for the selected record", "Error", true);
//       }

//       setEditLoader(false);
//     } catch (error: any) {
//       if (error?.response?.status === 401 || error?.response?.status === 403) {
//         setGenericMetaData("Authentication error. Please check your permissions for this entity.", "Error", true);
//       } else {
//         setGenericMetaData(`Error fetching record data: ${error?.message || 'Unknown error'}`, "Error", true);
//       }
//       setEditLoader(false);
//     }
//   };

//   return (
//     <>
//       <div className="content" style={{ paddingBlock: "8px", paddingInline: "8px", backgroundColor: "white", boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)", marginBottom: "10px" }}>
//         <div className="edit-header-container">
//           {/* <div className="edit-icon-container"><RenderSvg name="Edit-icon-black" /></div> */}
//           <IconButton onClick={() => {
//             navigate(-1);
//           }} size="small">
//             <ArrowBack sx={{ fontSize: 20, color: '#333' }} />
//           </IconButton>
//           <span className="content-text" style={{ fontSize: "18px", fontWeight: 500 }}>{translate(TranslationEnum.common_portal, `Edit a record for ${mdmState?.name}`)}</span>
//         </div>
//         <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '8px' }}>

//           <MdmFilterSelect
//             isOpen={filterDropdownOpen}
//             setIsOpen={(open) => {
//               setFilterDropdownOpen(open);
//               // Reset states when closing the dropdown
//               if (!open) {
//                 setActiveFilterType('');
//                 setFilterSearchValue('');
//               }
//             }}
//             searchValue={filterSearchValue}
//             setSearchValue={(v: string) => {
//               setFilterSearchValue(v);
//               // Only call filter-values API if dropdown is open and a filter type is active
//               if (filterDropdownOpen && activeFilterType) {
//                 getTableRows(
//                   endPoint,
//                   1,
//                   undefined,
//                   { mode: 'filters', which: activeFilterType, q: v }
//                 );
//               }
              
//             }}
//             selectedOptions={selectedFilterOptions}
//             setSelectedOptions={async (opts: Record<string, string[]>) => {
//               setSelectedFilterOptions(opts);
//               setCurrentPage(1);
              
//               await getTableRows(
//                 endPoint,
//                 1,
//                 searchedValue,
//                 undefined, 
//                 opts // NEW filterOptions parameter with fresh state
//               );
//             }}
//             activeFilterType={activeFilterType}
//             setActiveFilterType={setActiveFilterType}
//             visibleColumns={visibleColumns}
//             fetchFilterValues={(which: string, q?: string) =>
//               getTableRows(
//                 endPoint,
//                 1,
//                 undefined,
//                 { mode: 'filters', which, q }
//               ) as unknown as Promise<string[]>
//             }
//             onClearAll={async () => {
//               setSelectedFilterOptions({});
//               setFilterSearchValue('');
//               setActiveFilterType(''); // Reset active filter type
//               setCurrentPage(1);
//               // Pass empty filters object directly
//               await getTableRows(
//                 endPoint,
//                 1,
//                 searchedValue,
//                 undefined, // options
//                 {} // Empty filters
//               );
//             }}
//           />
//           <TextField
//             placeholder="Search"
//             size="small"
//             value={searchedValue}
//             onChange={(e) => {
//               setSeacrhedvalue(e.target.value);
//               debouncingTheSearch(e.target.value);
//             }}
//             sx={{
//               width: 250,
//               '& .MuiOutlinedInput-root': {
//                 height: '36px',
//                 fontSize: '14px',
//                 backgroundColor: '#fff'
//               },
//               '& .MuiInputBase-input': { padding: '8px 12px' },
//             }}
//             InputProps={{
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <IconButton
//                     sx={{
//                       p: 0.6,
//                       backgroundColor: '#237C9D',
//                       borderRadius: '50%',
//                       '&:hover': {
//                         backgroundColor: '#1e6b7d'
//                       }
//                     }}
//                   >
//                     <Search sx={{ fontSize: 18, color: '#fff' }} />
//                   </IconButton>
//                 </InputAdornment>
//               ),
//             }}
//           />
//           <Button
//             variant="contained"
//             onClick={() => {
//               toggleModal(true);
//             }}
//             sx={{
//               backgroundColor: '#237C9D',
//               color: '#fff',
//               fontSize: '14px',
//               textTransform: 'none',
//               height: '36px',
//               '&:hover': {
//                 backgroundColor: '#1e6b7d'
//               }
//             }}
//           >
//             {translate(TranslationEnum.common_portal, "Add New Record")}
//           </Button>
//         </div>
//       </div>

//       <ConfirmationPopUp
//         openConfirmModal={confirmationPopUp}
//         message={popUpMessage}
//         setOpenConfirmModal={() => {
//           setConfirmationPopUp(false);
//         }}
//         successMethod={popUpSuccessMethod.current}
//       />


//       <Modal
//         style={{ zIndex: 100 }}
//         open={openModal}
//         onClose={() => {
//           toggleModal(false);
//           setModelData(undefined);
//         }}
//       >
//         <Box>
//           <ConfigurationDashboard>
//             <DynamicFormPage
//               setRefresh={setRefresh}
//               mdmState={mdmState}
//               formConfig={selectedFormConfig}
//               initialData={modelData}
//               onBack={() => {
//                 toggleModal(false);
//                 setModelData(undefined);
//               }
//               }
//             />
//           </ConfigurationDashboard>
//         </Box>
//       </Modal>


//       <GenericPopUp
//         type={genericModaltype}
//         message={genericModalMessage}
//         openGenericModal={genericModalState}
//         setOpenGenericModal={() => {
//           genericModaltype === 'Success' && getTableRows(endPoint, currentPage, searchedValue);
//           setResetFiltersFlag(!resetFiltersFlag);
//           mdmFiltersRef.current = {};
//           setGenericModalState(false);
//         }}
//       />
//       {loader || editLoader ? (
//         <Loader />
//       ) : (
//         <div className="table-style" style={{ marginTop: "0px", height: "85vh" }}>
//           <GenericTable
//             searchedProps={searchProps}
//             table={{
//               rows,
//               columns,
//               getRowId: (row: any) => row.id ?? row.outlet_id ?? row.outlet_code,
//               isOfflineSearchEnable: false,
//               hideFooter: true,
//             }}
//           />
//           <div className="pagination">
//             <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
//               {/* Prev Button */}
//               <IconButton
//                 disabled={currentPage === 1}
//                 onClick={async () => {
//                   const newPage = currentPage - 1;
//                   if (newPage < 1) return;
//                   setCurrentPage(newPage);
//                   await getTableRows(
//                     endPoint,
//                     newPage,
//                     searchedValue,
//                     undefined,
//                     selectedFilterOptions // Pass current filters
//                   );
//                 }}
//               >
//                 <ArrowBack />
//               </IconButton>

//               <IconButton
//                 onClick={async () => {
//                   const newPage = currentPage + 1;
//                   setCurrentPage(newPage);
//                   await getTableRows(
//                     endPoint,
//                     newPage,
//                     searchedValue,
//                     undefined,
//                     selectedFilterOptions // Pass current filters
//                   );
//                 }}
//               >
//                 <ArrowForward />
//               </IconButton>
//             </Box>
//           </div>
//           {openReportModal ? (
//             <DownloadLoader
//               message={"Your report will be downloaded shortly."}
//               openReportModal={openReportModal}
//               setOpenReportModal={setOpenReportModal}
//             />
//           ) : null}
//         </div>
//       )}
//     </>
//   );
// };
